module.exports = (parcelRequire.load("14FgH")).then(() => parcelRequire('kXVEY'));